/*** IMPORTS FROM imports-loader ***/
(function() {

define([],
    function () {
        var paintData = {
            "brands": {
                "Behr": {
                    "Interior Paint": [
                        {
                            "name": "Behr Marquee",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-marquee.png",
                            "performance": "Best",
                            "coverage": "1 Coat",
                            "durability": "100",
                            "washability": "100",
                            "stainBlocking": "100",
                            "odorVOCContent": "Low Odor/Low VOC"
                        },
                        {
                            "name": "Behr Ultra",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-ultra.png",
                            "performance": "Better",
                            "coverage": "2 Coats",
                            "durability": "100",
                            "washability": "75",
                            "stainBlocking": "75",
                            "odorVOCContent": "Low Odor/Low VOC"
                        },
                        {
                            "name": "Behr Premium Plus Lifetime Warranty",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-premium-plus.png",
                            "performance": "Good",
                            "coverage": "2 Coats",
                            "durability": "75",
                            "washability": "50",
                            "stainBlocking": "0",
                            "odorVOCContent": "Low Odor/Zero VOC*"
                        }
                    ],
                    "Exterior Paint": [
                        {
                            "name": "Behr Marquee",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-marquee.png",
                            "performance": "Best",
                            "coverage": "2 Coats",
                            "durability": "100", 
                            "washability": "100", 
                            "stainBlocking": "100", 
                            "odorVOCContent": "Yes" 
                        },
                        {
                            "name": "Behr Ultra",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-ultra.png",
                            "performance": "Better",
                            "coverage": "2 Coats",
                            "durability": "50", 
                            "washability": "75", 
                            "stainBlocking": "100", 
                            "odorVOCContent": "No" 
                        },
                        {
                            "name": "Behr Premium Plus Lifetime Warranty",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/behr-premium-plus.png",
                            "performance": "Good",
                            "coverage": "2 Coats",
                            "durability": "25", 
                            "washability": "50", 
                            "stainBlocking": "25", 
                            "odorVOCContent": "No" 
                        }
                    ]
                },
                "Glidden - PPG": {
                    "Interior Paint": [
                        {
                            "name": "PPG Timeless",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/ppg-timeless.png",
                            "performance": "Best",
                            "coverage": "1 Coat",
                            "durability": "75",
                            "washability": "50",
                            "stainBlocking": "75",
                            "odorVOCContent": "Low Odor/Low VOC"
                        },
                        {
                            "name": "PPG Diamond",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/ppg-diamond.png",
                            "performance": "Better",
                            "coverage": "2 Coats",
                            "durability": "75",
                            "washability": "50",
                            "stainBlocking": "0",
                            "odorVOCContent": "Low Odor/Zero VOC*"
                        },
                        {
                            "name": "Glidden Premium",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/glidden-premium.png",
                            "performance": "Better",
                            "coverage": "2 Coats",
                            "durability": "50",
                            "washability": "25",
                            "stainBlocking": "0",
                            "odorVOCContent": "Low Odor/Zero VOC*"
                        },
                        {
                            "name": "Glidden Essentials",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/glidden-essentials.png",
                            "performance": "Good",
                            "coverage": "Primer Plus 2 Coats",
                            "durability": "25",
                            "washability": "25",
                            "stainBlocking": "0",
                            "odorVOCContent": "Low Odor/Low VOC"
                        }
                    ],
                    "Exterior Paint": [
                        {
                            "name": "PPG Timeless",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/ppg-timeless.png",
                            "performance": "Best",
                            "coverage": "1 Coat",
                            "durability": "100",
                            "washability": "100", 
                            "stainBlocking": "100", 
                            "odorVOCContent": "No" 
                        },
                        {
                            "name": "Glidden Premium",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/glidden-premium.png",
                            "performance": "Better",
                            "coverage": "2 Coats",
                            "durability": "25", 
                            "washability": "25", 
                            "stainBlocking": "25", 
                            "odorVOCContent": "No" 
                        },
                        {
                            "name": "Glidden Essentials",
                            "image": "https://assets.homedepot-static.com/p/static/images/paint/glidden-essentials.png",
                            "performance": "Good",
                            "coverage": "Primer Plus 2 Coats",
                            "durability": "0", 
                            "washability": "25", 
                            "stainBlocking": "0", 
                            "odorVOCContent": "No" 
                        }
                    ]
                }
            },
            "sheens": [
                {
                    "name": "Flat/Matte",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/flat-matte.png",
                    "washability": "25",
                    "finishPerformance": "Low sheen, non-reflective appearance",
                    "bestUses": "Low Traffic Areas",
                    "bestSuitedLocations": [
                        "Living Rooms",
                        "Dining Rooms",
                        "Ceilings",
                        "Bedrooms"
                    ]
                },
                {
                    "name": "Eggshell",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/eggshell.png",
                    "washability": "50",
                    "finishPerformance": "Soft, velvety appearance",
                    "bestUses": "Moderate Traffic Areas",
                    "bestSuitedLocations": [
                        "Living Rooms",
                        "Dining Rooms",
                        "Hallways",
                        "Family Room"
                    ]
                },
                {
                    "name": "Satin",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/satin.png",
                    "washability": "75",
                    "finishPerformance": "Soft, pearl-like appearance",
                    "bestUses": "High Traffic Areas",
                    "bestSuitedLocations": [
                        "All Interior Spaces",
                        "Kitchen",
                        "Bathrooms",
                        "Kid's Rooms"
                    ]
                },
                {
                    "name": "Semi-Gloss",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/semi-gloss.png",
                    "washability": "100",
                    "finishPerformance": "Soft, pearl-like appearance",
                    "bestUses": "High Traffic Areas",
                    "bestSuitedLocations": [
                        "Bathrooms",
                        "Doors & Windows",
                        "Trim",
                        "Cabinets"
                    ],
                },
                {
                    "name": "High-Gloss",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/high-gloss.png",
                    "washability": "100",
                    "finishPerformance": "Brilliant, shiny appearance",
                    "bestUses": "Very High Traffic Areas",
                    "bestSuitedLocations": [
                        "Doors & Windows",
                        "Trim",
                        "Cabinets",
                        "Shutters"
                    ],
                }
            ],
            "estimatesPerRoom": [
                {
                    "name": "Small Room",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/Small_Room_Illustration.png",
                    "roomSize": "1 - 400",
                    "amountNeeded": "1 Gallon"
                },
                {
                    "name": "Medium Room",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/Medium_Room_Illustration.png",
                    "roomSize": "401 - 1,600",
                    "amountNeeded": "2 - 4 Gallons"
                },
                {
                    "name": "Large Room",
                    "image": "https://assets.homedepot-static.com/p/static/images/paint/Large_Room_Illustration.png",
                    "roomSize": "1,601 - 3,200",
                    "amountNeeded": "4 - 8 Gallons"
                }
            ]
        }

        var getPaintData = function getPaintData() {
        
            return paintData;
        }

        return {
            getPaintData: getPaintData
        }
    });
}.call(window));